import { useAuth } from '@/lib/auth/auth';
import type { OrgActivityListResult } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

export const organizationActivityKeys = {
  all: ['organization-activity'] as const,
  detail: (organizationID: string, venueID?: string | null) =>
    [...organizationActivityKeys.all, organizationID, venueID ?? 'all-venues'] as const,
};

export function useOrganizationActivity(organizationID: string, venueID?: string | null, enabled = true) {
  const session = useAuth((state) => state.session);
  const request = useAuth((state) => state.request);
  const search = new URLSearchParams();
  if (venueID) {
    search.set('venue_id', venueID);
  }

  return useQuery({
    queryKey: organizationActivityKeys.detail(organizationID, venueID),
    enabled: Boolean(session) && enabled && organizationID.length > 0,
    queryFn: () =>
      request<OrgActivityListResult>(
        `/organizations/${organizationID}/activity${search.toString() ? `?${search.toString()}` : ''}`
      ),
  });
}
